<template>
  <div class="index">
    <div @click="enter" class="enter">
      <img src="../assets/btn.png" alt="">
    </div>
    <div class="tips" @click="show=true">项目说明</div>
    <div class="absolute" v-show="show">
      <img src="../assets/show.png" alt="">
      <div class="close" @click="show=false"></div>
    </div>
    <!-- <div class="text">
      中小企业的科技创新、文化创意与实现城市高质量发展密不可分，
      中国青年报结合以往报道资源、创业教育资源推出青春小店，
      纪录青年创客在各个城市的成长与发展，通过地图定位的方式展示小微企业，
      更好的为创客服务。目前，青春小店已经收录1121家，遍布全国31个省份，
      200座城市。青春小店地图将逐步升级，为众创空间、青年创业者、投资机构、
      服务机构创造新的连接，促进地方的交流与合作，打造一片专属创业垂类的“青春元宇宙”
    </div> -->
  </div>
</template>

<script>
export default {
  data() {
    return {
      show: false
    }
  },
  methods: {
    enter() {
      this.$router.push({
        name: "main"
      })
    }
  }
}
</script>

<style scoped>
.index {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background: url("../assets/index.jpg");
  background-size: 100% 100%;
}
.enter {
  position: absolute;
  /* border: 1px solid red; */
  top: 62%;
  left: 50%;
  height:45px;
  transform: translateX(-50%);
}
.enter img {
  width: 120px;
}
.tips {
  position: absolute;
  width: 100px;
  text-align: center;
  font-size: 14px;
  color: #ffffff;
  text-decoration:underline;
  top: 69%;
  left: 50%;
  transform: translateX(-50%);
}

.text {
  position: absolute;
  top: 70%;
  font-size: 12px;
  margin: 15px;
  text-align: justify;
  color: #ffffff;
  background-color: rgba(0,0,0,.5);
  padding: 15px;
}
.absolute{
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0,0,0,.65);
}
.absolute img {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 90%;
  transform: translate(-50%,-50%);
}
.close {
  position: absolute;
  top: 78%;
  left: 50%;
  transform: translateX(-50%);
  width: 40px;
  height: 80px;
  /* border: 1px solid red; */
}
</style>